import { render, staticRenderFns } from "./WarehouseDetail.vue?vue&type=template&id=3cf891ed"
import script from "./WarehouseDetail.vue?vue&type=script&lang=js"
export * from "./WarehouseDetail.vue?vue&type=script&lang=js"
import style0 from "./WarehouseDetail.vue?vue&type=style&index=0&id=3cf891ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports